import React, { useEffect, useState } from 'react'
import api from '../api'
import { Puzzle } from 'lucide-react'
import { Card, PageHeader, Badge } from '../components/ui'

export default function DriverOlt() {
  const [drivers, setDrivers] = useState([])

  useEffect(() => { load() }, [])

  async function load() {
    const res = await api.get('/olt-perangkat/drivers')
    setDrivers(res.data)
  }

  return (
    <div>
      <PageHeader
        title="Driver OLT"
        subtitle="Katalog driver/vendor OLT yang didukung aplikasi — read-only, mengikuti kode di server/olt/. Nambah vendor baru butuh 1 file driver ditulis developer, tapi nambah UNIT dari vendor yang sudah ada di sini cukup lewat halaman Perangkat OLT."
      />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: 14 }}>
        {drivers.map(d => (
          <Card key={d.key} style={{ padding: 18 }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 12 }}>
              <div style={{
                width: 42, height: 42, borderRadius: 10, flexShrink: 0,
                background: 'var(--brand-soft)', color: 'var(--brand-soft-text)',
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}><Puzzle size={19} /></div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 14.5 }}>{d.vendor}</div>
                <div style={{ fontSize: 11.5, color: 'var(--text-faint)', fontFamily: 'monospace' }}>driver key: {d.key}</div>
              </div>
              <Badge tone={d.jumlahPerangkat > 0 ? 'success' : 'neutral'}>
                {d.jumlahPerangkat} perangkat
              </Badge>
            </div>

            <div style={{ fontSize: 13, marginBottom: 8 }}>
              <span style={{ color: 'var(--text-muted)' }}>Model / Seri: </span>
              <span style={{ fontWeight: 600 }}>{d.model}</span>
            </div>
            <div style={{ fontSize: 13, marginBottom: 8 }}>
              <span style={{ color: 'var(--text-muted)' }}>Protokol: </span>
              {d.protokol}
            </div>
            <div style={{ fontSize: 13, marginBottom: d.catatan ? 10 : 0 }}>
              <span style={{ color: 'var(--text-muted)' }}>Port default: </span>
              {d.portDefault}
            </div>
            {d.catatan && (
              <div style={{
                fontSize: 12, color: 'var(--text-muted)', background: '#f8f8fb',
                border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
                padding: '8px 10px', marginTop: 4
              }}>
                {d.catatan}
              </div>
            )}
          </Card>
        ))}
      </div>
    </div>
  )
}
